import { create } from "zustand";

interface PlaybackState {
  playMode: "song" | "score";
  isPlaying: boolean;
  currentChord: string;
  currentMeasure: number;   // index of the measure under the cursor (for the chord-grid view); -1 = none
  currentBeatTime: number;  // start time of the beat under the cursor — disambiguates repeated chords in a measure
  volume: number;      // 0..100
  cursorComp: number;  // ms

  setPlayMode: (m: "song" | "score") => void;
  setIsPlaying: (p: boolean) => void;
  setCurrentChord: (c: string) => void;
  setCurrentMeasure: (m: number) => void;
  setCurrentBeatTime: (t: number) => void;
  setVolume: (v: number) => void;
  setCursorComp: (ms: number) => void;
}

export const usePlaybackStore = create<PlaybackState>((set) => ({
  playMode: "song",
  isPlaying: false,
  currentChord: "—",
  currentMeasure: -1,
  currentBeatTime: -1,
  volume: 100,
  cursorComp: 100,
  setPlayMode: (playMode) => set({ playMode }),
  setIsPlaying: (isPlaying) => set({ isPlaying }),
  setCurrentChord: (currentChord) => set({ currentChord }),
  setCurrentMeasure: (currentMeasure) => set({ currentMeasure }),
  setCurrentBeatTime: (currentBeatTime) => set({ currentBeatTime }),
  setVolume: (volume) => set({ volume }),
  setCursorComp: (cursorComp) => set({ cursorComp }),
}));
